import React from "react";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import IconButton from "@mui/material/IconButton";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import CloseIcon from "@mui/icons-material/Close";
import { BottomSheet } from "@app.automotus.io/components/BottomSheet";
import { useIsMobile } from "@app.automotus.io/components/hooks";
import { TermsOfServiceWrapper } from "./TermsOfServiceWrapper";

/**
 * Read-only terms of service shown over the current page, so the page underneath keeps its state.
 * Renders as a bottom sheet on mobile and a dialog on desktop.
 */
export const TermsOfServiceDialog: React.FC<TermsOfServiceDialogProps> = ({ open, onClose }) => {
  const isMobile = useIsMobile();

  if (isMobile) {
    return (
      <BottomSheet open={open} onClose={onClose} marginTopSmall={75} marginTopMedium={79}>
        <AppBar
          sx={{
            height: "52px",
            position: "relative",
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Toolbar sx={{ display: "flex", flexDirection: "row", justifyContent: "space-between", width: "100%" }}>
            <Box>
              <Typography variant="body3" sx={{ fontWeight: 500, ml: 1 }}>
                Terms Of Service
              </Typography>
            </Box>
            <Box>
              <IconButton edge="end" color="inherit" onClick={onClose} aria-label="close">
                <Box
                  sx={{
                    width: "28px",
                    height: "28px",
                    borderRadius: "100px",
                    backgroundColor: "rgba(0, 0, 0, 0.135)",
                  }}
                >
                  <CloseIcon sx={{ fontSize: "14px" }} />
                </Box>
              </IconButton>
            </Box>
          </Toolbar>
        </AppBar>
        <DialogContent sx={{ px: 3, pt: 0, mb: -2.5 }}>
          {/* The sheet's app bar is the title, so hide the one inside the terms */}
          <TermsOfServiceWrapper variant="display" onBack={onClose} hideTitle />
        </DialogContent>
      </BottomSheet>
    );
  }

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth PaperProps={{ sx: { borderRadius: 1.5 } }}>
      <DialogContent sx={{ pb: 0 }}>
        <TermsOfServiceWrapper variant="display" onBack={onClose} />
      </DialogContent>
    </Dialog>
  );
};

export default TermsOfServiceDialog;

/** Props passed to initialize a {@link TermsOfServiceDialog} component */
export interface TermsOfServiceDialogProps {
  /** Whether the dialog is open */
  open: boolean;
  /** Handler fired when the user closes the dialog */
  onClose: () => void;
}
